import {
  DEFAULT_WIDE_BREAKPOINT,
  DEFAULT_MEDIUM_BREAKPOINT,
  NumericBreakpoint,
} from 'app/constants/Breakpoints';

const getPageBreakpoint = ({ width }: { width: number }) => (
  width >= DEFAULT_WIDE_BREAKPOINT ? NumericBreakpoint.Wide :
  width >= DEFAULT_MEDIUM_BREAKPOINT ? NumericBreakpoint.Medium :
  NumericBreakpoint.Narrow
);

export default getPageBreakpoint;
